import React from 'react';
import HeroSection1 from '../components/herosections/HeroSection1';
import TrustedBrands from '../components/home/TrustedBrands';
import AboutUs from '../components/home/AboutUs';
import Services from '../components/home/Services';
import Team from '../components/home/Team';
import FAQs from '../components/home/FAQs';
import Blog from '../components/home/Blog';


const Home = () => {
  return (
    <>
      <HeroSection1 />
      <TrustedBrands />
      <AboutUs />
      <Services />
      <Blog />
      <Team />
      <FAQs />
    </>
  )
}

export default Home;
